/**
 * Gera o rótulo de contagem para filter bar e rodapé do DataTable.
 *
 * Exemplos:
 *   countLabel(8, 8)  → "8 itens"
 *   countLabel(3, 8)  → "3 de 8 itens"
 *   countLabel(1, 1)  → "1 item"
 */
export function countLabel(shown: number, total: number): string {
  const suffix = total === 1 ? " item" : " itens";
  if (shown === total) {
    return `${total}${suffix}`;
  }
  return `${shown} de ${total}${suffix}`;
}
